module.exports = __webpack_public_path__ + "static/nelson-9e9479b5d724a99ae47cbfcda8222adb.jpg";